import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientLayout from '../../components/layout/ClientLayout';
import { Loader2 } from 'lucide-react';

// SECURITY: Clients cannot see full plan - redirect to current session
const ClientPlanView = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to session of the day
    navigate('/portal/session', { replace: true });
  }, [navigate]);
  
  return (
    <ClientLayout>
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    </ClientLayout>
  );
};

export default ClientPlanView;
